import CustomAmplitudeClient from "./custom-amplitude-client.b75422c9d833.js";

class ContactProvider {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);

    this.elements = {
      contactButtons: document.querySelectorAll(".contact-provider-button"),
    };

    this.bindListeners();
  }

  bindListeners() {
    this.elements.contactButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        const contactMethod = e.target.dataset.method;
        this.amplitudeClient.trackEngageContactProvider(
          contactMethod,
          "cost breakdown page",
        );
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ContactProvider();
});
